import React from "react";
import {
  ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip,
} from "recharts";

const AXIS_TICK = { fill: "rgba(244,246,250,0.62)", fontSize: 11, fontFamily: "IBM Plex Mono, monospace" };

function ChartTooltip({ active, payload, label, formatter }) {
  if (!active || !payload || !payload.length) return null;
  const v = payload[0].value;
  return (
    <div
      data-testid="venture-mom-chart-tooltip"
      className="rounded-md border border-border bg-card px-3 py-2 shadow-[0_12px_30px_rgba(0,0,0,0.55)]"
    >
      <p className="text-[11px] text-muted-foreground font-mono">{label}</p>
      <p className="font-mono tabular-nums text-sm text-foreground">
        {formatter ? formatter(v) : v}
      </p>
    </div>
  );
}

export const MoMChart = ({ data = [], dataKey, formatter, height = 150, testId }) => {
  return (
    <div data-testid={testId || "venture-mom-chart"} style={{ height }} className="w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
          <CartesianGrid stroke="rgba(244,246,250,0.08)" vertical={false} />
          <XAxis dataKey="label" tick={AXIS_TICK} axisLine={{ stroke: "rgba(244,246,250,0.12)" }} tickLine={false} />
          <YAxis
            tick={AXIS_TICK}
            axisLine={false}
            tickLine={false}
            width={46}
            tickFormatter={formatter}
          />
          <Tooltip
            content={<ChartTooltip formatter={formatter} />}
            cursor={{ stroke: "rgba(244,246,250,0.15)" }}
          />
          <Area
            type="monotone"
            dataKey={dataKey}
            stroke="#2B4FD8"
            strokeWidth={2}
            fill="rgba(43,79,216,0.14)"
            dot={false}
            activeDot={{ r: 3, fill: "#007BFF", stroke: "#007BFF" }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};
